"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createInputFeature = function (featureId) {
    var type = "SET_" + featureId.toUpperCase();
    var reducer = function (state, action) {
        var _a, _b, _c;
        state = __assign((_a = {}, _a[featureId] = {}, _a), state);
        if (action !== undefined &&
            action.type === type &&
            action.payload !== undefined &&
            action.payload.inputId !== undefined &&
            action.payload[featureId] !== undefined) {
            return __assign({}, state, (_b = {}, _b[featureId] = __assign({}, state[featureId], (_c = {}, _c[action.payload.inputId] = action.payload[featureId], _c)), _b));
        }
        return state;
    };
    var actionCreator = function (dispatch) { return function (payload) { return dispatch({ type: type, payload: payload }); }; };
    var selectorCreator = function (inputId) { return function (state) { return state[featureId] && state[featureId][inputId]; }; };
    return {
        actionCreator: actionCreator,
        selectorCreator: selectorCreator,
        featureReducer: reducer,
    };
};
//# sourceMappingURL=createFeature.js.map